module.exports = __webpack_public_path__ + "static/golf.c6fc6f6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activities/golf.jpg
// module id = 392
// module chunks = 23718644409033